import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getSeasonName } from "../../helpers/seasonName";
import { getSeasonImage } from "../../helpers/season";
import { getConservatoryAlias } from "../../helpers/conservatories";
import { formatPrice } from "../../helpers/formatPrice";

import ConservatoryImage from "../ConservatoryImage/ConservatoryImage";
import SvgComponent from "../SvgComponent/SvgComponent";

import {
  PreviewContainer,
  FrameName,
  UterumSummary,
  SquareMeter,
  SquareMeterDetails,
  PriceLabel,
  OrdinaryPriceLabel,
  DiscountedPrice,
  FrameSeason,
  NameAndSeason,
  SeasonIcon,
  DiscountList,
} from "./style";

const Preview = ({ renderDimensions = false, dataId }) => {
  const init = useSelector((state) => state.init);
  const Uterum = useSelector((state) => state.Uterum);
  const Result = useSelector((state) => state.Result);

  const { alias, currency } = init;
  const { Season, FrameType, FrameWidth, FrameDepth } = Uterum;
  
  const { SquareMeterStomme, Price, OrdinaryPrice, Discounts, ProductDiscount } = Result;

  const seasonTitle = getSeasonName(alias, Season);

  const seasonMisc = getSeasonImage(Season);
  const frameTypeTitle = getConservatoryAlias(FrameType, alias);
  const formattedPrice = formatPrice(Price, currency);
  const formattedOrdinaryPrice = formatPrice(OrdinaryPrice, currency);
  const formattedProductDiscount = formatPrice(ProductDiscount, currency);

  const hasProductDiscounts = (Price !== OrdinaryPrice) && (ProductDiscount >= 1); // If the discount is in decimals it showed up as 0

  return (
    <PreviewContainer data-id={dataId} className="Preview">
      <ConservatoryImage
        // frameType and smaller are used to determine special style properties for FIRAXL, LYCKA, FIRAVINKEL and Uterum.ground
        frameType={FrameType}
        smaller={Uterum.Ground ? true : false}
      />
      <NameAndSeason>
        <FrameName data-id={`${dataId}__FrameName`}>{frameTypeTitle}</FrameName>
        <FrameSeason data-id={`${dataId}__FrameSeason`}>
          <SeasonIcon>
            <SvgComponent name={seasonMisc.iconName} />
          </SeasonIcon>
          <span>{seasonTitle}</span>
        </FrameSeason>
      </NameAndSeason>
      <UterumSummary>
        <div>
          <SquareMeter>
            {SquareMeterStomme} m<sup>2</sup>
            {renderDimensions && (
              <SquareMeterDetails>
                ({FrameWidth}x{FrameDepth})
              </SquareMeterDetails>
            )}
          </SquareMeter>
          <PriceLabel>
            {!hasProductDiscounts && Discounts.length < 1 ? (
              <span>{formattedOrdinaryPrice}</span>
            ) : (
              <>
                <DiscountedPrice>{formattedPrice}</DiscountedPrice>
                <OrdinaryPriceLabel>{formattedOrdinaryPrice}</OrdinaryPriceLabel>
              </>
            )}
          </PriceLabel>
        </div>
        {
          Discounts.length > 0 ? (
            <DiscountList>
              {Discounts.map(discount => {
                return <li key={discount.PromotionName}>{discount.PromotionName}: &minus; {discount.FormattedDiscount}</li>;
              })}
              {hasProductDiscounts ? <li>{alias.bfcDiscount} &minus; {formattedProductDiscount}</li> : ''}
            </DiscountList>
          ) : ''
        }
      </UterumSummary>
    </PreviewContainer>
  );
};

Preview.propTypes = {
  renderDimensions: PropTypes.bool,
  dataId: PropTypes.string,
};

export default Preview;
